/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Media_Caption_SelectionInputs */



/**
* | output |
* | --- |
* | "Media and Caption Selection" |
*
* @param {Embed_Captions_Media_Caption_SelectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_media_caption_selection = /** @type {((inputs?: Embed_Captions_Media_Caption_SelectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Media_Caption_SelectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selection du media et des sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medien- und Bildunterschriftenauswahl")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezione di media e didascalie")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выбор медиафайлов и субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Selección de medios y subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("媒体和字幕选择")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアとキャプションの選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया और कैप्शन चयन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seleção de mídia e legendas")
	return /** @type {LocalizedString} */ ("Media and Caption Selection")
});